import React, {useCallback} from "react";
import {useParams} from "react-router";
import {DiaEditorCreateRedirectFunction, useDiaEditor} from "../../components/DiaEditor";
import {NonIdealState} from "../../components/NonIdealState";
import WaitSpinner from "../../components/wait-spinner";
import * as yup from "yup";
import {
    CreateOptionMutation,
    GetOptionQueryResult, Option, UpdateOptionMutation, UpdateOptionMutationResult,
    useCreateOptionMutation, useGetOptionQuery,
    useUpdateOptionMutation

} from "../../generated/graphql";
import OptionForm from "./Form";
import {uniqueId} from "../../utils";
import { MutationResult } from "@apollo/client/react";


function blankValues(): Option {
    return {
        id: uniqueId(),
        label: '',
        code:'',
        type:'html'
    };
}


const schema = yup.object().shape({
    label: yup.string().min(1),
    code: yup.string().min(8),
});


export function OptionEditor() {
    const params = useParams();
    const isNew = (params.id=='new');
    const query = useGetOptionQuery({variables:{id:params.id},skip:isNew});
    const [saveMutation,saveResult] = useUpdateOptionMutation();
    const [createMutation,createResult] = useCreateOptionMutation();
    const save = useCallback(({values})=>{
        return saveMutation({variables:{input:values}});
    },[]);
    const create = useCallback(({values})=>{
        return createMutation({variables:{input:values}});
    },[]);
    const getValue = useCallback((result:GetOptionQueryResult)=>{
        return result?.data?.option;
    },[]);
    const getSaveValue = useCallback((result:UpdateOptionMutationResult)=>{
        return result?.data?.updateOption;
    },[]);
    const getCreateRedirect = useCallback<DiaEditorCreateRedirectFunction<MutationResult<CreateOptionMutation>>>(({data,baseUrl})=>{
        return baseUrl+(data.data?.createOption?.id);
    },[]);

    const data = useDiaEditor<Option,GetOptionQueryResult,CreateOptionMutation,UpdateOptionMutation>({save,saveResult,create,createResult,query:query,
        baseUrl:'/database/options/',
        blankValues:blankValues,
        label:'Options',
        permission:'options',
        validationSchema:schema,
        getValue:getValue,
        getSaveValue:getSaveValue,
        getCreateRedirect:getCreateRedirect
    });

    if (query.error) {
        return <NonIdealState
            severity="error"
            title="An error has occurred"
            message="GraphQL error encountered"
        />;
    }
    if(data.form.status=='loading') {
        return <WaitSpinner variant="panel"/>;
    }
    return <>{data.confirmation}<OptionForm waiting={data.waiting} diaForm={data.form} /></>;
}